module.exports = __webpack_public_path__ + "img/18068 copy.d37c48fd.jpg";